export const LIST_CONSULTATIONS = 'LIST_CONSULTATIONS';
export const LIST_CONSULTATIONS_SUCCESS = 'LIST_CONSULTATIONS_SUCCESS';
export const LIST_CONSULTATIONS_FAILED = 'LIST_CONSULTATIONS_FAILED';
